/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-process-env */
/* eslint-disable security/detect-object-injection */
import mfeConfig from '../../config/webpack.config.js/mfeConfig.json'

const env = process.env.BUILD_TARGET_ENV

const mfeApps = mfeConfig.mfeApps[env]

export default mfeApps
